<style lang="scss">

</style>

<template>
  <button
    class="btn btn-outline-purple btn-sub-header-menu float-right mr-20px"
    @click="openModal()"
  >
    <i class="fa fa-cloud-upload" /> {{ __('Importar') }}
    <BModal
      id="modal-import-automation"
      ref="modal-import-automation"
      hide-footer="hide-footer"
      modal-class="modal-width-380"
    >
      <template slot="modal-title">
        {{ __('Importar Modelo de Campanha') }}
      </template>
      <template slot="default">
        <form v-dropzone="dropzone" />
      </template>
    </BModal>
  </button>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  data () {
    return {
      dropzone: {
        defaultMessage: 'Clique aqui ou arraste seu arquivo JSON para iniciar',
        action: '/automation/import',
        faIcon: 'fa-plus',
        success: this.fileUploadedCallback,
        error: this.fileUploadedError,
        keepFiles: false,
        accept: (file, done) => {
          const regex = new RegExp('^.*\\.(json|JSON)$');

          if (regex.test(file.name)) {
            return done();
          }

          done('Envie o arquivo no formato JSON');
        },
      },
    };
  },

  methods: {
    openModal () {
      this.$refs['modal-import-automation'].show();
    },

    fileUploadedCallback (e) {
      if (e.xhr.status == 201) {
        Alert.success(this.__('Campanha importada.'));

        setTimeout(() => window.location.href = `/automation/${JSON.parse(e.xhr.response).id}`, 1200);

        return;
      }

      Alert.error(this.__('Problema ao importar campanha. Tente novamente'));
    },

    fileUploadedError (e) {
      if (e.xhr.status == 403) {
        const { error } = JSON.parse(e.xhr.response);

        if (error) {
          return Alert.error(error);
        }
      }

      Alert.error(this.__('Problema ao importar campanha. Tente novamente'));
    },
  },
};
</script>
